import React from "react";
import {useSelector} from "react-redux";
import {IAppState} from "../../../../store/models";
import {Box, Typography} from "@mui/material";
import {ReactComponent as TooltipIcon} from "../../../../assets/icons/tooltip_ok_icon.svg";
import {makeStyles} from "@mui/styles";

const useStyles = makeStyles(() => ({
    tooltipPopup: {
        width: `100%`,
        display: `flex`,
        flexFlow: `row`,
        padding: `5px`,
        alignItems: `center`,
    }
}))

interface PropsTooltip {
    frameTitle: string;
}

export const CustomTooltipContent: React.FC<PropsTooltip> = ({
                                                                 frameTitle
                                                             }) => {
    const {flyersBranch} = useSelector((state: IAppState) => state);
    const isHebrewStyle = flyersBranch.data?.dir === "RTL";
    const classes = useStyles();
    if (!frameTitle) {
        return (
            <></>
        )
    }
    return (
        <Box
            className={classes.tooltipPopup}
            sx={{direction: isHebrewStyle ? `rtl` : `ltr`}}>
            <Box sx={{
                flex: `1 1 auto`
            }}>
                <Typography sx={{
                    fontFamily: flyersBranch.data?.font.toLowerCase(),
                    fontSize: `12px`,
                    fontWeight: `500`
                }}>
                    {frameTitle}
                </Typography>
            </Box>
            <Box sx={{
                width: `10px`,
                height: `8px`,
                margin: isHebrewStyle ? `0 5px 0 0` : `0 0 0 5px`
            }}>
                <TooltipIcon style={{width: `100%`, height: `100%`}}/>
            </Box>
        </Box>
    )

}